export const namespace = 'tokens';

export const MutationTypes = {
  SET_TOKENS: 'SET_TOKENS',
};

export const ActionTypes = {
  GET_TOKENS: 'GET_TOKENS',
};
